<div class="modal">
  <div class="close-button-container">
    <app-modal-close-button
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
  <img src="assets/icons/winkliesel.gif" class="success-icon" />
  <p class="message"><b>Viel Spaß beim Shoppen!</b></p>
</div>
